module.exports = require("js-yaml");


//////////////////
// WEBPACK FOOTER
// external "js-yaml"
// module id = 20
// module chunks = 0